import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import { deleteData } from "../../hooks/delete";
import Swal from "sweetalert2";
import useSession from "../../hooks/useSession";
import GlobalForm from "../../components/globalForm/GlobalForm";
import CustomEditor from "../../components/shared/CustomEditor";

function InstructionPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState([]);
  const [user] = useSession();

  // filter by slug
  useEffect(() => {
    setFilteredData(apiData.filter((item) => !item.slug));
  }, [apiData]);

  const { instruction, instructionBn, _id } = filteredData[0] ?? {};

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  const update = (data) => {
    updateData(homeApi, data, _id);
  };

  return (
    <div className="p-4 lg:p-8">
      <h2
        className={`col-span-3 font-semibold text-2xl text-center w-full mb-12 mt-8`}
      >
        Update Instruction
      </h2>
      {_id && (
        <CustomEditor
          oldData={{ instruction, instructionBn }}
          saveDataHandler={update}
        />
      )}
    </div>
  );
}

export default InstructionPage;
